import { TimeSlot } from "@/pages/human-resources/time-management/business/time-slot/TimeSlot.ts";
import { parseIsoDateTime } from "@/shared/utils/Dates.ts";
import { sortByKey } from "@/shared/utils/Arrays.ts";
import type { HourlyTagCategoryResolver } from "@/pages/human-resources/time-management/business/reference/HourlyTagCategoryResolver.ts";

export interface TimeSlotOut {
  id: string | undefined;
  startTime: string;
  endTime: string;
  positionId?: number;
  breakDurationMinutes?: number;
  timeSlotCategoryId: string;
}

export function mapToSortedTimeSlots(
  resolver: HourlyTagCategoryResolver,
  dtos: TimeSlotOut[],
): TimeSlot[] {
  const timeSlots = dtos.map((dto) => mapToTimeSlot(resolver, dto));
  sortByKey(timeSlots, (ts) => ts.startTime.getTime());
  return timeSlots;
}

function mapToTimeSlot(
  resolver: HourlyTagCategoryResolver,
  tso: TimeSlotOut,
): TimeSlot {
  return new TimeSlot(
    resolver.idToCategory(tso.timeSlotCategoryId),
    tso.positionId?.toString(),
    tso.breakDurationMinutes ?? 0,
    tso.id,
    parseIsoDateTime(tso.startTime),
    parseIsoDateTime(tso.endTime),
  );
}
